import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Compare from './pages/Compare'
import Trends from './pages/Trends'
import Competitors from './pages/Competitors'
import CompetitorProfile from './pages/CompetitorProfile'
import Admin from './pages/Admin'
import { EmptyState } from './components/ui'
import ErrorBoundary from './components/ErrorBoundary'

export default function App() {
  return (
    <BrowserRouter>
      <Layout>
        <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/trends" element={<Trends />} />
          <Route path="/competitors" element={<Competitors />} />
          <Route path="/competitors/:id" element={<CompetitorProfile />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<EmptyState title="Not found" />} />
        </Routes>
        </ErrorBoundary>
      </Layout>
    </BrowserRouter>
  )
}
